import { getStatus } from "utils/utils";
import { getTaskStatusColor } from "utils/taskUtils";

const StatusBadge = ({ status, size = "md", className = "" }) => {
  const sizeClasses = size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs";
  return (
    <span
      className={`inline-flex items-center rounded-md font-semibold whitespace-nowrap ${sizeClasses} ${getTaskStatusColor(
        status
      )} ${className}`}
    >
      {getStatus(status) || "N/A"}
    </span>
  );
};

export default StatusBadge;
